// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-22T09:54:31Z                      #

// ##############################################################


/**
 * 
 */
enum TypeSign {
    CUSTOM = 'CUSTOM', 
    SIGN_COMBINATION = 'SIGN_COMBINATION', 
    NO_SIGN = 'NO_SIGN'
};
export default TypeSign;

